import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Zap } from 'lucide-react';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { Card } from '../components/ui/card';
import { toast } from 'sonner';

const LoginPage = () => {
  const [email, setEmail] = useState('');
  const { login, mockUsers } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = (e) => {
    e.preventDefault();
    const result = login(email, 'password');
    if (result.success) {
      toast.success(`Welcome back, ${result.user.name}!`);
      navigate('/');
    } else {
      toast.error('User not found. Try one of the demo emails.');
    }
  };

  const handleQuickLogin = (user) => {
    login(user.email, 'password');
    toast.success(`Logged in as ${user.name}`);
    navigate('/');
  };

  return (
    <div className="min-h-screen flex items-center justify-center" style={{ backgroundColor: 'hsl(var(--bg))' }}>
      <Card className="w-full max-w-md p-8">
        <div className="flex flex-col items-center mb-8">
          <div className="flex items-center justify-center w-16 h-16 rounded-2xl mb-4" style={{ backgroundColor: 'hsl(var(--primary))' }}>
            <Zap className="w-8 h-8" style={{ color: 'hsl(var(--primary-foreground))' }} fill="currentColor" />
          </div>
          <h1 className="text-3xl font-bold" style={{ fontFamily: 'Manrope, sans-serif' }}>GridCommons</h1>
          <p className="text-sm mt-2" style={{ color: 'hsl(var(--ink-muted))' }}>Knowledge-to-action platform for grid modernization</p>
        </div>

        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <Label htmlFor="email">Email</Label>
            <Input
              id="email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Enter your email"
              required
            />
          </div>
          <Button type="submit" className="w-full">
            Sign In
          </Button>
        </form>

        <div className="mt-8">
          <p className="text-xs font-semibold uppercase tracking-wider mb-3" style={{ color: 'hsl(var(--ink-muted))' }}>Quick Login (Demo)</p>
          <div className="space-y-2">
            {mockUsers.map((user) => (
              <button
                key={user.id}
                onClick={() => handleQuickLogin(user)}
                className="w-full text-left px-4 py-3 rounded-lg border"
                style={{
                  borderColor: 'hsl(var(--line))',
                  backgroundColor: 'hsl(var(--surface))'
                }}
              >
                <div className="font-medium text-sm">{user.name}</div>
                <div className="text-xs" style={{ color: 'hsl(var(--ink-muted))' }}>
                  {user.role.charAt(0) + user.role.slice(1).toLowerCase()} • {user.email}
                </div>
              </button>
            ))}
          </div>
        </div>
      </Card>
    </div>
  );
};

export default LoginPage;
